import React, { useState } from "react";
import siteLogo from "../../assets/img/logo.png";
import { Link } from "react-router-dom";
import { IoMdMail } from "react-icons/io";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className="navbar navbar-area navbar-expand-lg">
        <div className="container nav-container navbar-bg">
          <div className="responsive-mobile-menu">
            <button
              className="menu toggle-btn d-block d-lg-none"
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
            >
              <span className="icon-left"></span>
              <span className="icon-right"></span>
            </button>
          </div>
          <div className="logo">
            <Link to={"/"}>
              <img src={siteLogo} alt="img" />
            </Link>
          </div>
          <div className="nav-right-part nav-right-part-mobile">
            <a className="search-bar-btn" href="#">
              <i className="fa fa-search"></i>
            </a>
          </div>
          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
            id="itech_main_menu"
          >
            <ul className="navbar-nav menu-open text-lg-end">
              <li className="menu-item-has-children">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to={"/aboutUs"}>About</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to={"/services"}>Services</Link>
              </li>
              <li className="menu-item-has-children mega-menu">
                <Link to={"/contactUs"}>Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="nav-right-part nav-right-part-desktop align-self-center">
            <a className="navbar-phone" href="mailTo:techvoyagelab@gmail.com">
              <span className="icon">
                {/* <img src={logo1} alt="img" /> */}
                <IoMdMail style={{ fontSize: "2em" }} />
              </span>
              <span>Need help?</span>
              <h5>techvoyagelab@gmail.com</h5>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
